import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function FullStackDeveloperSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["full-stack-developer"]} />;
}
